import { useState } from 'react';
import type { Project } from '../../shared/types';
import { Modal } from './ui';
import {
  FIELD_LABELS,
  buildEntryControls,
  isComplete,
  type EntryDraft,
  type EntryField,
} from './EntryFormRow';

const ORDER: EntryField[] = ['work_date', 'project_id', 'title', 'work_type', 'minutes', 'remark'];

/** The stacked form used on small screens, where a table row cannot be edited. */
export function EntrySheet({
  title,
  draft,
  projects,
  submitting,
  onChange,
  onSubmit,
  onClose,
}: {
  title: string;
  draft: EntryDraft;
  projects: Project[];
  submitting: boolean;
  onChange: (draft: EntryDraft) => void;
  onSubmit: () => void;
  onClose: () => void;
}) {
  const [attempted, setAttempted] = useState(false);

  const controls = buildEntryControls({
    draft,
    projects,
    onChange,
    showErrors: attempted,
    compact: false,
  });

  const submit = () => {
    setAttempted(true);
    if (isComplete(draft)) onSubmit();
  };

  return (
    <Modal
      title={title}
      onClose={onClose}
      footer={
        <>
          <button type="button" className="btn btn-ghost" onClick={onClose}>
            Cancel
          </button>
          <button type="button" className="btn btn-primary" onClick={submit} disabled={submitting}>
            {submitting ? 'Saving…' : 'Save entry'}
          </button>
        </>
      }
    >
      <div className="space-y-4">
        {ORDER.map((field) => (
          <div key={field}>
            <span className="label">{FIELD_LABELS[field]}</span>
            {controls[field]}
            {field === 'minutes' && (
              <p className="mt-1.5 text-[12px] text-[var(--color-ink-muted)]">
                Accepts 1:30, 1.5, 90m or 1h30.
              </p>
            )}
          </div>
        ))}
      </div>
    </Modal>
  );
}
